import styled from "styled-components";

interface IContainerListProps {
    filterAreaHeight: number;
}

export const ContainerListHeader = styled.div`
    background-color: #fafafa;
    display: flex;
    padding-right: 5px;
`;

export const ContainerList = styled.div<IContainerListProps>`
    overflow-y: scroll;
    overflow-x: hidden;
    max-height: ${props => 45 - props.filterAreaHeight}vh;
    height: ${props => 45 - props.filterAreaHeight}vh;
    background-color: #fff;

    @media screen and (min-width: 700px) and (min-height: 1000px) {
        max-height: ${props => 65 - props.filterAreaHeight}vh;
        height: ${props => 65 - props.filterAreaHeight}vh;
    }

    @media screen and (min-width: 800px) and (min-height: 1000px) {
        max-height: ${props => 70 - props.filterAreaHeight}vh;
        height: ${props => 70 - props.filterAreaHeight}vh;
    }

    @media screen and (min-width: 700px) and (min-height: 900px) {
        max-height: ${props => 60 - props.filterAreaHeight}vh;
        height: ${props => 60 - props.filterAreaHeight}vh;
    }

    @media screen and (min-width: 1100px) and (min-height: 500px) {
        max-height: ${props => 55 - props.filterAreaHeight}vh;
        height: ${props => 55 - props.filterAreaHeight}vh;
    }

    @media screen and (min-width: 1100px) and (min-height: 700px) {
        max-height: ${props => 60 - props.filterAreaHeight}vh;
        height: ${props => 60 - props.filterAreaHeight}vh;
    }

    @media screen and (min-width: 1100px) and (min-height: 850px) {
        max-height: ${props => 80 - props.filterAreaHeight}vh;
        height: ${props => 80 - props.filterAreaHeight}vh;
    }

    @media screen and (min-width: 1100px) and (min-height: 900px) {
        max-height: ${props => 70 - props.filterAreaHeight}vh;
        height: ${props => 70 - props.filterAreaHeight}vh;
    }

    @media screen and (min-width: 1200px) and (min-height: 850px) {
        max-height: ${props => 58 - props.filterAreaHeight}vh;
        height: ${props => 58 - props.filterAreaHeight}vh;
    }

    @media screen and (min-width: 1300px) and (min-height: 850px) {
        max-height: ${props => 66 - props.filterAreaHeight}vh;
        height: ${props => 66 - props.filterAreaHeight}vh;
    }

    @media screen and (min-width: 1400px) and (min-height: 700px) {
        max-height: ${props => 60 - props.filterAreaHeight}vh;
        height: ${props => 60 - props.filterAreaHeight}vh;
    }

    @media screen and (min-width: 1400px) and (min-height: 800px) {
        max-height: ${props => 63 - props.filterAreaHeight}vh;
        height: ${props => 63 - props.filterAreaHeight}vh;
    }

    @media screen and (min-width: 1400px) and (min-height: 850px) {
        max-height: ${props => 66 - props.filterAreaHeight}vh;
        height: ${props => 66 - props.filterAreaHeight}vh;
    }

    @media screen and (min-width: 1200px) and (max-height: 600px) {
        max-height: ${props => 45 - props.filterAreaHeight}vh;
        height: ${props => 45 - props.filterAreaHeight}vh;
    }
`

interface ITableDataProps {
  width?: string;
  textAlign?: string;
  backgroundColor?: string;
  fontSize?: string;
}

export const TableData = styled.td<ITableDataProps>`
  width: ${props => props.width || 'auto'};
  min-width: ${props => props.width || 'auto'};
  max-width: ${props => props.width || 'auto'};
  text-align: ${props => props.textAlign || 'left'};
  background-color: ${props => props.backgroundColor || '#fff'} !important;
  font-size: ${props => props.fontSize || '1em'};
`;

export const TableHead = styled.th<ITableDataProps>`
  width: ${props => props.width || 'auto'};
  min-width: ${props => props.width || 'auto'};
  max-width: ${props => props.width || 'auto'};
  text-align: ${props => props.textAlign || 'left'};
`;